import React, { useEffect, useState } from 'react';
import CampaignPrizePanel from './campaignPrizePanel.component';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoading } from 'modules/notification';
import { getCampaignPrizeDatalist } from 'modules/reporting/redux';
import { unwrapResult } from "@reduxjs/toolkit";
import moment from 'moment';

export default function CampaignPrizePanelContainer({
    url, currentFilter, pageType, translate
}){
    const dispatch = useDispatch();

    const isFetchingCampaignPrizeDatalist = useSelector(state => selectLoading(state, getCampaignPrizeDatalist.typePrefix));
    const campaignPrizeDatalist = useSelector(state => state.reporting.campaign.campaignPrizeDatalist);

    const [tableFilter, setTableFilter] = useState({
        page: 0,
        rowsPerPage: 25,
        search: "",
        searchBy: "name",
        orderBy: "quantity",
        orderDirection: "desc",
    })

    useEffect(() => {
        dispatch(getCampaignPrizeDatalist({
            length: tableFilter.rowsPerPage,
            start: tableFilter.page * tableFilter.rowsPerPage,
            orderBy: tableFilter.orderBy,
            orderDirection: tableFilter.orderDirection,
            search: tableFilter.search,
            searchBy: tableFilter.searchBy,
            countryCode: currentFilter.countryCode,
            city_uuid: currentFilter.cityUuid,
            branch_uuid: currentFilter.branchUuid,
            period: currentFilter.period,
            campaign_uuid: currentFilter.campaignUuid,
            campaign_type: currentFilter.campaignType,
            start_date: moment(currentFilter.dateRange[0]).format('YYYY-MM-DD'),
            end_date: moment(currentFilter.dateRange[1]).format('YYYY-MM-DD'),
            url: url
        })).then(unwrapResult);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, tableFilter, currentFilter]);

    const handleChangePage = (e, newPage) => {
        setTableFilter((prev) => ({
          ...prev,
          page: newPage,
        }))
    }

    const handleChangeRowPerPage = (event) => {
        setTableFilter((prev) => ({
          ...prev,
          page: 0,
          rowsPerPage: event.target.value
        }))
    }

    const handleRequestSort = (event, property) => {
        const isAsc = tableFilter.orderBy === property && tableFilter.orderDirection === 'asc';
        setTableFilter((prev) => ({
            ...prev,
            orderDirection: isAsc ? 'desc' : 'asc',
            orderBy: property,
        }))
    }

    return (
        <CampaignPrizePanel 
            status={{
                isFetchingCampaignPrizeDatalist,
            }}

            data={{
                campaignPrizeDatalist,
            }}

            sort={{
                valueToOrderBy: tableFilter.orderBy,
                orderDirection: tableFilter.orderDirection,
                handleRequestSort: handleRequestSort,
            }}

            pagination={{
                page: tableFilter.page,
                rowsPerPage: tableFilter.rowsPerPage,
                rowsPerPageOptions: [5, 10, 25],
                handleChangePage: handleChangePage,
                handleChangeRowPerPage: handleChangeRowPerPage,
            }}

            currentFilter={currentFilter}

            pageType={pageType}
            translate={translate}
        />
    )
}